import { render } from "./TodoList.vue?vue&type=template&id=2fe57576&scoped=true"
import script from "./TodoList.vue?vue&type=script&lang=js"
export * from "./TodoList.vue?vue&type=script&lang=js"

import "./TodoList.vue?vue&type=style&index=0&id=2fe57576&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fe57576"]])

export default __exports__